module.exports = __webpack_public_path__ + "img/20220219_072724.70674503.jpg";